import React from "react";
import Typography from "@material-ui/core/Typography";
import MaterialTable, {MTableToolbar} from "material-table";
import tableicons from "../tableicons";
import {Card, CardActions, CardContent, Grid} from "@material-ui/core";
import {Autocomplete} from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import es from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import Button from "@material-ui/core/Button";
import {clientesResources, inventarioResources} from "../endpoints";
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import SnackbarAlert from "../components/SnackbarAlert";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import {green} from "@material-ui/core/colors";

class AgregarInventario extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            disabled_descargar:false,
            disabled_gestion: false,
            cliente: '',
            disabled: true,
            clientes: [],
            tiendas:[],
            selectedDate: new Date(),
            comentario:'',
            tienda: '',
            inv_programados : [],
            openSnack: false,
            severity: '',
            message: '',
            confirmar: false,
            progress: false,
            loadingGestion: false, 
        };
    }

    handleDateChange = (date) => {
        this.setState({selectedDate: date});
    };

    obtenerClientes = () =>{
        clientesResources.getClientes().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(data => {
            this.setState({clientes:data})
        }).catch(error=> {
            console.error(error);
        });
    }

    handleChange = e =>{
        this.setState({[e.target.name]: e.target.value});
    }

    componentDidMount() {
        this.obtenerClientes()

    }

    agregarIniciar = () =>{
        this.setState({openSnack:false, severity: null, message:null, progress:true})
        const fecha = this.state.selectedDate.toLocaleDateString().split("-").reverse().join("-")
        const id_cliente  = this.state.cliente.id
        let invNuevo ={
            fecha: fecha,
            comentario: this.state.comentario,
            id_tienda: this.state.tienda.id
        }

        inventarioResources.agregarIniciarInv(invNuevo,id_cliente).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.setState({progress: false, confirmar:false,openSnack:true, severity: result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
            this.setState({progress: false, confirmar:false,openSnack:true, severity: 'error', message:"Ha ocurrido un error inesperado"})
        });
    }

    obtenerTiendasCliente = () =>{
        this.setState({disabled:false})
        if(this.state.cliente !== ''){
            clientesResources.getTiendasCliente(this.state.cliente.id).then(async response => {
                if (response.ok) {
                    return await response.json();
                } else {
                    throw new Error('Something went wrong ...');
                }
            }).then(data => {
                this.setState({tiendas:data})
            }).catch(error=> {
                console.error(error);
            });
        }
    }
    
    obtenerInvProgramados =() =>{
        var d = new Date(this.state.selectedDate),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        const fecha = [year, month, day].join('-');

        this.setState({openSnack:false, severity: null, message:null})
        inventarioResources.getInvProgramados(this.state.tienda.id, fecha).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(data => {
            if(data.status_code === 200){
                this.setState({inv_programados:data.inv_programados})
            }
            else if (data.status_code === 401){
                this.setState({openSnack:true, severity:data.severity, message:data.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.error(error);
        });
    }

    gestionUpdate = () => {
        this.setState({ disabled_gestion: true, openSnack: false, loadingGestion: true });

        inventarioResources.gestionUpdate().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(data => {
            this.setState({
                disabled_gestion: false,
                loadingGestion: false, // <--- Cerrar diálogo de carga
                openSnack: true, 
                severity: 'success', 
                message: "Actualización de inventarios realizada de forma correcta"
            });
        }).catch(error => {
            this.setState({
                disabled_gestion: false,
                loadingGestion: false, // <--- Cerrar diálogo de carga en caso de error
                openSnack: true, 
                severity: 'error', 
                message: "Error al actualizar los inventarios disponibles"
            });
            console.error(error);
        });
    }

    onChangeTienda =(newValue) =>{
        this.setState({tienda: newValue}, this.obtenerInvProgramados)
    }

    iniciarInventario = (rowData) =>{
        this.setState({openSnack:false})
        const folio = rowData.id
        const app = rowData.app
        const id_cliente = rowData.id_cliente
        inventarioResources.iniciarInv(folio,app,id_cliente).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.setState({severity:result.severity, openSnack:true, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
            this.setState({severity:"error", openSnack:true, message:"Ha ocurrido un error inesperado"})
        });
    }

    render() {
        return (
            <div>
                <Typography variant="h4" gutterBottom>
                    Agregar inventario
                </Typography>
                <Card>
                    <CardContent>
                        <Grid container>
                            <Grid item xs={3} style={{padding: '10px'}}>
                                <Autocomplete
                                    id="size-small-standard"
                                    onChange={(event, newValue) => {
                                        if(newValue === null) {
                                            this.setState({cliente: '', tienda: '', disabled: true})
                                        }
                                        else{
                                            this.setState({cliente: newValue, disabled:true}, this.obtenerTiendasCliente)

                                        }
                                    }}
                                    size="small"
                                    options={this.state.clientes}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.descripcion || ""}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" label="Clientes" placeholder="Disponibles" />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={3} style={{padding: '10px'}}>
                                {
                                    !this.state.disabled &&
                                    <Autocomplete
                                        id="size-small-standard"
                                        onChange={(event, newValue) => {
                                            if(newValue === null) {
                                                this.setState({tienda: ''})
                                            }
                                            else{
                                                this.onChangeTienda(newValue)
                                            }
                                        }}
                                        size="small"
                                        options={this.state.tiendas}
                                        noOptionsText={"No hay opciones"}
                                        getOptionLabel={(option) => option.descripcion + " - " + option.centro || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="standard" label="Tienda" placeholder="Disponibles" />
                                        )}
                                    />
                                }

                            </Grid>
                            <Grid item xs={2} style={{marginTop: '-9px', paddingRight:'10px', paddingLeft: '10px'}} >
                                <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
                                    <Grid container>
                                        <KeyboardDatePicker
                                            disableToolbar
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-picker-inline"
                                            label="Fecha"
                                            value={this.state.selectedDate}
                                            onChange={this.handleDateChange}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </Grid>
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={4} style={{padding: '7px'}}>
                                <TextField value={this.state.comentario} name="comentario" label="Comentarios" fullWidth onChange={this.handleChange}/>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <CardActions style={{display:'flex', justifyContent:'end'}}>
                        <Button disabled={!this.state.selectedDate || !this.state.tienda} size="large" variant="contained" color="primary" onClick={()=>this.setState({confirmar:true})}>
                            Agregar e iniciar
                        </Button>
                    </CardActions>
                </Card>
                <br/>
                <MaterialTable
                    title="Inventarios programados"
                    icons={tableicons}
                    columns={[
                        { title: 'Folio', field: 'id' },
                        { title: 'Fecha', field: 'fecha',
                            render : (rowData => rowData.fecha.split("-").reverse().join("/")),
                            customFilterAndSearch: ((term, rowData) => rowData.fecha.split("-").reverse().join("/").indexOf(term) !== -1),
                        },
                        { title: 'Cliente', field: 'cliente_des' },
                        { title: 'Tienda', field: 'tienda_des' },
                        { title: 'Comentarios', field: 'comentario' },
                    ]}
                    data={this.state.inv_programados}
                    actions={[
                        {
                            icon: () => <PlayCircleFilledIcon/>,
                            tooltip: 'Iniciar inventario',
                            onClick: (event, rowData) => this.iniciarInventario(rowData)
                        },
                    ]}
                    options={{
                        pageSize: 25,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense"
                    }}
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar'
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        }
                    }}
                    components={{
                        Toolbar: props => (
                            <div>
                                <MTableToolbar {...props} />
                                <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                                    <Grid item>
                                        <Button disabled={this.state.disabled_gestion} variant="contained" name="avance" color="primary" onClick={() => this.gestionUpdate()}>
                                            Actualizar
                                        </Button>
                                        {this.state.disabled_gestion && (
                                            <CircularProgress size={24} style={{color: green[500], position: "absolute", top: "50%", left: "50%", marginTop: -12, marginLeft: -12}} />
                                        )}
                                    </Grid>
                                </Grid>
                            </div>
                        ),
                    }}
                />
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                <Dialog
                    open={this.state.confirmar}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">Se agregará e iniciará inventario</DialogTitle>
                    <DialogContent style={{display:'grid'}}>
                        <Grid container  direction="row" spacing={1}>
                            <Grid item xs={12}>
                                <Typography variant={"subtitle1"}>
                                    Con los siguientes datos:
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant={"subtitle1"}>
                                    Fecha: {this.state.selectedDate.toLocaleDateString().split("-").reverse().join("-")}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant={"subtitle1"}>
                                    Comentario: {this.state.comentario}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant={"subtitle1"}>
                                    Tienda: {this.state.tienda.descripcion + " - " + this.state.tienda.centro }
                                </Typography>
                            </Grid>
                        </Grid>
                        {this.state.progress ? <CircularProgress style={{display: 'inline-grid', justifySelf: 'center'}}/>: null}
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={this.state.progress} variant="contained" color="secondary" onClick={()=>this.setState({confirmar: false})}>
                            Cancelar
                        </Button>
                        <Button disabled={this.state.progress} variant="contained" color="primary" onClick={this.agregarIniciar}>
                            Confirmar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Diálogo de carga para la actualización de gestión */}
                <Dialog open={this.state.loadingGestion} disableBackdropClick disableEscapeKeyDown>
                    <DialogContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '30px' }}>
                        <CircularProgress color="primary" />
                        <Typography variant="h6" style={{ marginTop: '15px' }}>
                            Actualizando datos desde Gestión...
                        </Typography>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}
export default AgregarInventario;